<span
  matTooltipPosition="above"
  [matTooltip]="message.twilio.dateCreated | fsFormatDate : 'medium'"
>
  {{ message.twilio.dateCreated | fsFormatDate : 'shortTime' }}
</span>
